import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
} from "@/utils/type-vaildator";
import api from "./api";

interface VoiceRenameResponse {
  is_duplicate: boolean,
}

class VoiceRenameData {
  @Required("isDuplicate cannot be empty")
  @IsBoolean("isDuplicate must be a boolean")
  isDuplicate: boolean;
}

const transformAndValidateData = (
  response: VoiceRenameResponse
): VoiceRenameData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, VoiceRenameData);
  } catch (error) {
    console.error("Actor rename list data validation failed:", error.message);
    throw error;
  }
};

/** 音频重命名 */
export const voiceRename = async ({ id, name, userId }: { id: string, name: string, userId?: string }) => {
  const res = await api.post<VoiceRenameResponse>('/audio/rename-template', {
    audio_id: id,
    audio_name: name,
    user_id: userId,
  });
  const data = transformAndValidateData(res.data);  
  return data;
}